import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppConfiguration } from '../../services/configuration/app.configuration';
import { isStripeRequest } from '../stretchit-api-headers/request-classifier';

export const stripeAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isStripeRequest(req)) return next(req);

  const appConfiguration = inject(AppConfiguration);

  return next(
    req.clone({
      headers: req.headers.set('Authorization', `Basic ${appConfiguration.stripeToken}`),
    })
  );
};
